var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadytoGojobposted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4808_13680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F3F4F6",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0874 16.4011L15.3547 16.5349C14.8726 16.5722 14.4432 16.8249 14.1765 17.2282L12.1782 20.2505C11.976 20.5564 11.9438 20.9392 12.0922 21.2745C12.2405 21.6098 12.5454 21.8435 12.9077 21.8996L14.4942 22.1453C14.8653 20.1758 15.7538 18.2111 17.0874 16.4011ZM20.8547 28.5058L21.1004 30.0923C21.1566 30.4546 21.3903 30.7595 21.7255 30.9078C21.8622 30.9685 22.01 30.9999 22.1596 31C22.3695 30.9998 22.5746 30.9379 22.7495 30.8218L25.7719 28.8235C26.1752 28.5568 26.4279 28.1274 26.4651 27.6453L26.599 25.9126C24.7889 27.2463 22.8243 28.1347 20.8547 28.5058ZM20.258 27.4062C20.3131 27.4062 20.3685 27.4016 20.4238 27.3924C21.2489 27.2544 22.0442 27.022 22.8029 26.7178L16.2822 20.1971C15.978 20.9558 15.7456 21.7511 15.6076 22.5763C15.5533 22.9015 15.6624 23.2329 15.8955 23.4661L19.5339 27.1045C19.7275 27.2981 19.9888 27.4062 20.258 27.4062ZM30.4053 19.8673C32.0009 16.7824 32.06 13.5224 31.9766 11.9935C31.9481 11.4696 31.5304 11.052 31.0065 11.0234C30.7146 11.0077 30.4223 10.9999 30.13 11C28.4204 11 25.7153 11.2589 23.1327 12.5948C21.0803 13.6564 18.3891 15.9939 16.8013 19.0658C16.82 19.0805 16.8383 19.096 16.8556 19.1133L23.8868 26.1445C23.9041 26.1617 23.9196 26.18 23.9342 26.1988C27.0061 24.6109 29.3437 21.9197 30.4053 19.8673ZM23.6287 15.2281C24.771 14.0859 26.6296 14.0858 27.7719 15.2281C28.3252 15.7814 28.63 16.5172 28.63 17.2997C28.63 18.0822 28.3252 18.818 27.7719 19.3713C27.2008 19.9423 26.4504 20.2279 25.7003 20.228C24.95 20.228 24.2 19.9425 23.6287 19.3713C23.0754 18.818 22.7706 18.0822 22.7706 17.2997C22.7706 16.5172 23.0754 15.7814 23.6287 15.2281Z",
    fill: "url(#paint0_linear_4808_13680)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4572 18.539C25.1426 19.2243 26.2578 19.2244 26.9431 18.539C27.2751 18.2069 27.458 17.7655 27.458 17.296C27.458 16.8265 27.2751 16.3851 26.9431 16.0531C26.6005 15.7104 26.1503 15.5391 25.7002 15.5391C25.2501 15.5391 24.7999 15.7104 24.4573 16.0531C24.1253 16.3851 23.9424 16.8265 23.9424 17.296C23.9424 17.7655 24.1252 18.207 24.4572 18.539ZM12.5977 27.4782C12.7477 27.4782 12.8976 27.421 13.012 27.3066L14.925 25.3936C15.1538 25.1647 15.1538 24.7938 14.925 24.5649C14.6962 24.3361 14.3252 24.3361 14.0964 24.5649L12.1834 26.4779C11.9546 26.7068 11.9546 27.0777 12.1834 27.3066C12.2377 27.3611 12.3023 27.4043 12.3734 27.4337C12.4445 27.4632 12.5207 27.4783 12.5977 27.4782ZM16.6781 26.3181C16.4494 26.0893 16.0783 26.0893 15.8495 26.3181L12.1716 29.996C11.9428 30.2248 11.9428 30.5958 12.1716 30.8246C12.286 30.939 12.436 30.9962 12.586 30.9962C12.7359 30.9962 12.8859 30.939 13.0002 30.8246L16.6781 27.1467C16.907 26.9179 16.907 26.5469 16.6781 26.3181ZM17.6026 28.0713L15.6897 29.9843C15.4609 30.2131 15.4609 30.5841 15.6897 30.8129C15.8041 30.9273 15.9541 30.9845 16.104 30.9845C16.2539 30.9845 16.4039 30.9273 16.5183 30.8129L18.4313 28.8999C18.6601 28.6711 18.6601 28.3001 18.4313 28.0713C18.2025 27.8424 17.8315 27.8424 17.6026 28.0713Z",
    fill: "url(#paint1_linear_4808_13680)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4808_13680",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4808_13680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4808_13680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4808_13680",
    x1: 22,
    y1: 11,
    x2: 22,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4808_13680",
    x1: 19.729,
    y1: 15.5391,
    x2: 19.729,
    y2: 30.9962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadytoGojobposted);
export default __webpack_public_path__ + "static/media/Ready to Go job posted.69b1baa6792aff4ae8dd21466f40bb45.svg";
export { ForwardRef as ReactComponent };